export const sortByPValue = (associationA, associationB) => parseFloat(associationA.pvalue) - parseFloat(associationB.pvalue);
